/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Fab, Grid} from "@mui/material";
import {AddAPhoto, VideoFile,} from "@mui/icons-material";
import imgDefecto from '../Recursos/imgDefecto.svg'
import {useEffect, useState} from "react";


const IngresoVideo = ({
                          props,
                          dato,

                      }) => {
    const {getValues, setValue, watch} = props
    const [imagen, setImagen] = useState('')

    const ingresoImagen = (data) => {
        if (data.target.files && data.target.files[0]) {
            setValue(dato, data.target.files[0])
        }
    }


    useEffect(() => {
        let obj = getValues()

        if (typeof obj[dato] === 'object') {
            setImagen(URL.createObjectURL(obj[dato]))
        } else {
            setImagen(obj[dato])
        }


    }, [watch(dato)]);
    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            size={{xs: 12, sm: 12, md: 12}}
        >
            <Grid item container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                {!imagen ?

                    <img src={imgDefecto} width={100} height={'auto'}/>
                    :
                    <video style={{width: '100%'}} loop muted controls={true}
                    >
                        <source src={imagen} type='video/mp4'/>
                    </video>
                }

            < /Grid>

            <Grid item container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'center', marginTop: -5, mr: 0}}>
                <Fab
                    variant="contained"
                    component="label"
                    sx={{p: 2}}
                >
                    <input
                        type="file"
                        hidden
                        onChange={ingresoImagen}
                        accept="video/mp4"

                    />
                    <VideoFile color={'primary'} sx={{width: 30, height: 30}}/>

                </Fab>
            </Grid>


        </Grid>

    )

}
export default IngresoVideo
